import * as Sentry from '@sentry/browser';
import Game from './Game';
import { reportedOnce, setReportEnabledTo } from './report';
import { filterStateData } from 'Utility/Sentry/SentryHelpers';

let sentryEnabled = false;
let cacheduserID: string = null;

export function sentryInit() {
    Sentry.init({
        release: Game.config.release,
        dsn: '',
        environment: process.env.NODE_ENV,
        ignoreErrors: [
            'Non-Error promise rejection captured with keys: code, message',
            'There is currently a pending request for locking message: flushplayerdataasync',
            'InvalidStateError: Failed to start the audio device',
            /^NETWORK_FAILURE$/,
        ],
        // Append redux state.
        beforeSend(event, hint?) {
            event.extra = {
                ...event.extra,
                'filtered-state-data': filterStateData(event),
            };

            if (hint) {
                if (hint.data && hint.data.message) {
                    event.extra.hint = hint.data.message;
                }
                if (hint.originalException) {
                    const { code, message } = hint.originalException as any;

                    if (code || code === 0) {
                        event.tags = { ...event.tags, exceptionCode: code };
                    }
                    if (message) {
                        event.tags = {
                            ...event.tags,
                            exceptionMessage: message,
                        };
                    }

                    if (
                        (typeof message === 'string' &&
                            // FIXME: fix the original place
                            // According to sentry this error happens on timer's tick,
                            // therefore I assume some reducer crashes,
                            // what leaves the store in "reducer is executing" state
                            message.indexOf('You may not call store.getState() while the reducer is executing') >= 0) ||
                        message.indexOf('Maximum call stack size exceeded') >= 0
                    ) {
                        if (reportedOnce[message]) return null;
                        reportedOnce[message] = true;
                        // FIXME: add `[once]` prefix to the error, like `report` does
                    }
                }
            }

            const userID = cacheduserID || (cacheduserID = Game.sdk.getUserId()) || 'unknown';
            console.log('User ID: ' + userID);
            if (event && event.tags) event.tags.userID = userID;

            return event;
        },
    });

    sentryEnabled = false;
    setReportEnabledTo(sentryEnabled);
    setSentryUserID(Game.sdk.getUserId());
}

export function setSentryUserID(ID: string) {
    if (!sentryEnabled || !ID) return;

    // literally does nothing
    Sentry.configureScope(scope => {
        scope.setUser({ id: ID });
    });
}

export function captureException(err: any) {
    console.log(err);
    if (!sentryEnabled) return;
    if (err instanceof Error || err.message === undefined) {
        Sentry.captureException(err);
    } else {
        console.info(JSON.stringify(err));
        Sentry.captureException(new Error(err.message));
    }
}
